import BarList, { BarListRow } from '@/components/ui/BarList.tsx';
import {
  InfoCard,
  InfoCardBody,
  InfoCardHeader,
} from '@/components/ui/InfoCard.tsx';
import NoItems from '@/components/ui/NoItems.tsx';
import { STATUS_TONE_COLORS } from '@/components/ui/statusTone.ts';
import { resolveSegmentIdentity } from '@/components/charts/breakdownAdapter.ts';
import { BreakdownDto } from '@/types/stats/BreakdownDto.ts';
import { BOOKING_SOURCE_REGISTRY } from '@/features/dashboard/tours/types/sales/bookingSources.utils.ts';
import { barShare } from '@/features/dashboard/tours/types/share.utils.ts';
import { pluralize } from '@/utils/pluralize.ts';

interface BookingSourceCardProps {
  /** `total` to wszystkie rezerwacje wyjazdu — nie suma segmentów. */
  bookingSources: BreakdownDto;
}

/** Skąd wzięły się rezerwacje — powracający, rodzeństwo, kod, wejście wprost. */
const BookingSourceCard = ({ bookingSources }: BookingSourceCardProps) => {
  const rows: BarListRow[] = bookingSources.segments.map((segment, index) => {
    const { id, label } = resolveSegmentIdentity(
      segment,
      BOOKING_SOURCE_REGISTRY,
      index,
    );

    return {
      id,
      label,
      value: segment.value,
      pct: barShare(segment.value, bookingSources.total),
    };
  });

  return (
    <InfoCard>
      <InfoCardHeader
        title="Skąd przychodzą"
        aside={
          <span className="text-[13px] text-neutral-400">
            {pluralize(
              bookingSources.total,
              'rezerwacja',
              'rezerwacje',
              'rezerwacji',
            )}
          </span>
        }
      />
      <InfoCardBody>
        {rows.length > 0 ? (
          <>
            <BarList rows={rows} color={STATUS_TONE_COLORS.success.dot} />
            <p className="text-[13px] text-neutral-400">
              Jedna rezerwacja może mieć kilka źródeł, więc udziały się
              nakładają.
            </p>
          </>
        ) : (
          <NoItems
            title="Brak danych o źródłach"
            description="Żadna rezerwacja nie ma jeszcze przypisanego źródła."
          />
        )}
      </InfoCardBody>
    </InfoCard>
  );
};

export default BookingSourceCard;
